import { render, staticRenderFns } from "./VentaPasoTres.vue?vue&type=template&id=d8e5fa60"
import script from "./VentaPasoTres.vue?vue&type=script&lang=js"
export * from "./VentaPasoTres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports